import { createElement, Mail, MessageCircle } from "lucide";
import { RESOURCE_ICONS } from "./resource_icons";

const ICON_ATTRIBUTE = "data-massimo-icon";
const CHIP_SIZE = 12;
const PREVIEW_SIZE = 14;

// Renderers emit a placeholder name, never SVG markup: only a name in this map becomes an icon.
const ICONS = Object.fromEntries([
  ...Object.entries(RESOURCE_ICONS).map(([name, component]) => [name, { component, size: CHIP_SIZE }]),
  ["message-email", { component: Mail, size: PREVIEW_SIZE }],
  ["message-sms", { component: MessageCircle, size: PREVIEW_SIZE }],
]);

export function iconPlaceholder(name) {
  return ICONS[name] ? `<span ${ICON_ATTRIBUTE}="${name}"></span>` : "";
}

export function upgradeIcons(root) {
  root.querySelectorAll(`[${ICON_ATTRIBUTE}]`).forEach((placeholder) => {
    const icon = ICONS[placeholder.getAttribute(ICON_ATTRIBUTE)];
    if (icon) {
      placeholder.replaceWith(createElement(icon.component, { width: icon.size, height: icon.size }));
    } else {
      placeholder.remove();
    }
  });
}
